import uniqBy from 'lodash/uniqBy';
import { mapPersonaToPickerOption } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.utils';
import { PersonaCollection } from '@sdk/personaCollection/types/PersonaCollection';
import { Persona } from '@sdk/personaCollection/types/Persona';
import { User } from '@sdk/users/types/User';
import { UserStatus } from '@sdk/users/types/UserStatus';

export const isUser = (persona: Persona): persona is User => persona.type === 'user';

export const mapPersonaToSuggestions = (personaCollection: PersonaCollection) => {
  const personas = Object.values(personaCollection.personasDict);
  const allPersonas = uniqBy([personaCollection.users, personas].flat(), 'id');
  const pickerPersonas = allPersonas
    .filter((persona) => {
      if (isUser(persona)) {
        return persona.isActive && !persona.deleted && persona.status === UserStatus.verified;
      }

      return 'archivedAt' in persona && !persona.archivedAt;
    })
    .map(mapPersonaToPickerOption);

  const memberIds = allPersonas.map((p) => p.id);

  return {
    pickerPersonas,
    memberIds,
  };
};
